"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processActionsAndMessage = void 0;
const common_1 = require("../common");
const initializeSourceMap_1 = require("./initializeSourceMap");
exports.processActionsAndMessage = async (options) => {
    if (process.env.NODE_ENV === 'production' && process.env.NEO_ONE_DEV !== 'true') {
        return options.message;
    }
    initializeSourceMap_1.initializeSourceMap();
    return common_1.processActionsAndMessage(options);
};

//# sourceMappingURL=processActionsAndMessage.js.map
